import api from 'Application/api/api';

const moveTemplateGroupDown = (id, cancelToken = null) =>
    api.post(`project-manager/template-groups/${id}/move-down`, {
        cancelToken,
    });

export default moveTemplateGroupDown;
